import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageLayout from "./components/Layout/PageLayout";
import ChatPage from "./pages/ChatPage";
import HomePage from "./pages/HomePage";
import ModalSearch from "./pages/ModalSearch";
import SearchResultsPage from "./pages/SearchResultsPage";
import SettingsPage from "./pages/SettingsPage";
import LibraryPage from "./pages/LibraryPage";
import SidebarPage from "./pages/SidebarPage";

import "./styles.css";

function App() {
  return (
    <BrowserRouter>
      <PageLayout>
        <Routes>
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/modal-search" element={<ModalSearch />} />
          <Route path="/sidebar" element={<SidebarPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/library" element={<LibraryPage />} />
        </Routes>
      </PageLayout>
    </BrowserRouter>
  );
}

const rootElement = document.getElementById("root") as HTMLElement;

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
